export { default } from './CardNewClients'


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardNewClients/index.js